export default __webpack_public_path__ + "static/taylor-bitmoji-e1de33cd7e9627912ea162e2520dadfe.png";